import React, { forwardRef } from 'react';
import { getArrowPositionStyles } from './get-arrow-position-styles.mjs';

const FloatingArrow = forwardRef(
  ({ position, arrowSize, arrowOffset, arrowRadius, arrowPosition, visible, arrowX, arrowY, style, ...others }, ref) => {
    const dir = "ltr";
    if (!visible) {
      return null;
    }
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        ...others,
        ref,
        style: {
          ...style,
          ...getArrowPositionStyles({
            position,
            arrowSize,
            arrowOffset,
            arrowRadius,
            arrowPosition,
            dir,
            arrowX,
            arrowY
          })
        }
      }
    );
  }
);

export { FloatingArrow };
